export default __webpack_public_path__ + "static/media/angersmini.dc81edc7.jpg";